import styled from "styled-components";
import { breakpoints } from "themes/breakpoints";
import AppInfo from "./AppInfo";
import DataredeDriverImage from "./DataredeDriverImage";
import DataredeLogoImage from "./DataredeLogoImage";
import { containerStyle } from "./styles";
import { BannerProps, ContainerComponentProps } from ".";

const BannerSmallDevices = ({ data }: BannerProps) => {
  return (
    <Container backgroundSrc={data.background.path}>
      <DataredeLogoContainer>
        <DataredeLogoImage image={data.logo} />
      </DataredeLogoContainer>
      <StyledAppInfo data={data} />
      <DataredeDriverContainer>
        <DataredeDriverImage />
      </DataredeDriverContainer>
    </Container>
  );
};

export default BannerSmallDevices;

const Container = styled.div<ContainerComponentProps>`
  ${({ backgroundSrc }) => containerStyle(backgroundSrc)}
  padding: 30px 10vh 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (max-width: ${breakpoints.md}) {
    height: 100vh;
    padding: 30px;
  }
`;

const DataredeDriverContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 1;
  justify-content: center;

  @media (max-width: ${breakpoints.md}) {
    padding-top: 30px;
  }

  > div {
    max-width: 340px;
    width: 70vw;
    height: 100%;

    @media (max-width: ${breakpoints.sm}) {
      width: 100%;
    }

    img {
      width: 100%;
    }
  }
`;

const DataredeLogoContainer = styled.div`
  > img {
    width: 100px;
  }
`;

const StyledAppInfo = styled(AppInfo)`
  margin-top: 20px;
  max-width: 100%;
  font-size: 10px;

  @media (max-width: ${breakpoints.sm}) {
    font-size: 8px;
  }

  .app-buttons-container {
    svg {
      width: 140px;
    }
  }
`;
